<template>
  <div class="q-ml-md">
    <q-form @submit="editarUsuario">
      <div class="row col-12 q-col-gutter-sm text-weight-bold text-brand-1">
        <div class="col-2">
          <div class="q-ml-sm">ID Usuário</div>

          <q-input v-model="userId" bg-color="grey-3" disable dense outlined />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Matrícula</div>
          <q-input
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            v-model="dadosUsuarioEdicao.sap"
            dense
            outlined
            hide-bottom-space
          />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Perfil</div>
          <SelectPerfil
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            v-model="dadosUsuarioEdicao.perfil"
          />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Cargo</div>
          <q-input
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            dense
            hide-bottom-space
            v-model="dadosUsuarioEdicao.cargo"
            outlined
          />
        </div>
        <div class="col-6">
          <div class="q-ml-sm">Nome</div>
          <q-input
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            v-model="dadosUsuarioEdicao.name"
            dense
            hide-bottom-space
            outlined
          />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">COD Integração</div>
          <q-input
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            v-model="dadosUsuarioEdicao.codigo_integracao"
            dense
            hide-bottom-space
            outlined
          />
        </div>
        <div class="col-6">
          <div class="q-ml-sm">E-mail</div>
          <q-input
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            v-model="dadosUsuarioEdicao.email"
            dense
            outlined
            hide-bottom-space
          />
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Turno</div>
          <q-select
            v-model="dadosUsuarioEdicao.vendor_shift_id"
            :options="optionsTurno"
            dense
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            outlined
            emit-value
            hide-bottom-space
            map-options
            option-value="id"
            option-label="description"
          >
            <template v-slot:selected-item="scope">
              <span v-if="scope.opt.description"
                >{{ scope.opt.description }} - {{ scope.opt.start_time }} /
                {{ scope.opt.finish_time }}</span
              >
              <q-tooltip>
                <span v-if="scope.opt.description"
                  >{{ scope.opt.description }} - {{ scope.opt.start_time }} /
                  {{ scope.opt.finish_time }}</span
                >
              </q-tooltip>
            </template>
          </q-select>
        </div>
        <div class="col-4">
          <!-- <div>ID Usuário</div>
        <q-input dense outlined /> -->
        </div>
        <div class="col-2">
          <div class="q-ml-sm">Data Admissão</div>
          <q-input
            dense
            outlined
            hide-bottom-space
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            :bg-color="
              dadosUsuarioEdicao.status != 'Ativo' || disable ? 'grey-3' : ''
            "
            v-model="dadosUsuarioEdicao.admission_date"
            mask="##/##/####"
            fill-mask
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="dadosUsuarioEdicao.admission_date"
                    :options="optionsDate"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-3">
          <div class="q-ml-sm">Centro de Custo</div>
          <SelectCentroCustos
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            v-model="dadosUsuarioEdicao.cost_center"
          />
        </div>
        <div class="col-3">
          <div class="q-ml-sm">Função / Processo / GHE</div>
          <SelectGhe
            :disable="dadosUsuarioEdicao.status != 'Ativo' || disable"
            v-model="dadosUsuarioEdicao.gheObject"
          />
        </div>
      </div>
      <div class="row col-12 q-gutter-sm q-mt-lg q-ml-md q-mb-md items-center">
        <div>
          <q-btn
            style="border-radius: 8px"
            no-caps
            type="submit"
            :disable="!botaoHabilitado || disable"
            :style="
              !botaoHabilitado
                ? 'border-radius: 8px; background-color: #f1f1f1; color: #8A8A8A'
                : ' border-radius: 8px; background-color: green; color: white'
            "
            label="Salvar Edição"
            icon="save"
          />
        </div>
        <div>
          <q-btn
            icon="sync"
            no-caps
            :disable="disable"
            label="Indexar Regras"
            style="background-color: #304f78; border-radius: 8px; color: white"
            @click="indexarRegras"
          />
        </div>
        <div v-if="dadosUsuario.status != 'Ativo'" class="q-ml-lg">
          <q-btn
            label="Reativar"
            stack
            :disable="disable"
            icon="person_add"
            style="color: white; background-color: green; border-radius: 8px"
            @click="reativarUsuario"
          />
        </div>
        <div v-if="dadosUsuario.status === 'Ativo'" class="q-ml-lg">
          <q-btn
            label="Afastar"
            stack
            :disable="disable"
            icon="person_remove"
            style="color: white; background-color: #eebf00; border-radius: 8px"
            @click="afastarUsuario"
          />
        </div>
        <div v-if="dadosUsuario.status === 'Ativo'">
          <q-btn
            label="Desligar"
            stack
            :disable="disable"
            icon="person_off"
            style="color: white; background-color: #dd2153; border-radius: 8px"
            @click="desligarUsuario"
          />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script setup>
// import { defineProps } from "vue";
import { onMounted, ref, watch, computed, defineProps, provide } from "vue";

import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelectCentroCustos from "../../legado/compras/components/SelectCentroCustos.vue";
import SelectGhe from "./SelectGhe.vue";
import SelectPerfil from "./SelectPerfil.vue";

// const props = defineProps({
//   idUsuario: {},
// });

const store = useStore();
const quasar = useQuasar();

const dadosUsuario = ref({});
const dadosUsuarioEdicao = ref({});
const botaoHabilitado = ref(true);

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

provide("userId", userId);

const disable = ref(false);

const detalharUsuario = async () => {
  disable.value = true;

  try {
    const response = await store.dispatch(
      "simplificadoStore/getUserEspecifico",
      {
        id: userId.value,
      }
    );

    dadosUsuario.value = response.data.model;
    dadosUsuarioEdicao.value = { ...dadosUsuario.value };
    if (dadosUsuario.value.function_id) {
      dadosUsuarioEdicao.value.gheObject = {
        id: dadosUsuario.value.function_id,
        name: dadosUsuario.value.function,
      };
    }

    if (dadosUsuario.value?.roles.length > 0) {
      dadosUsuarioEdicao.value.perfil = dadosUsuario.value?.roles[0];
    }

    dadosUsuarioEdicao.value.admission_date = dadosUsuario.value.admission_date
      ?.split(" ")[0]
      ?.split("-")
      ?.reverse()
      .join("/");
    disable.value = false;
  } catch (error) {
    console.log(error);
    disable.value = false;
  }
};

const optionsTurno = ref([]);

const getTurnos = async () => {
  try {
    let response = await store.dispatch("simplificadoStore/getTurnos", {});

    optionsTurno.value = response.data.results;
  } catch (error) {
    console.log(error);
  }
};

const reativarUsuario = async () => {
  try {
    await store.dispatch("simplificadoStore/reativarUsuario", {
      id: dadosUsuarioEdicao.value.id,
    });
    detalharUsuario();
    quasar.notify({
      message: "Usuário reativado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
  }
};

const desligarUsuario = async () => {
  try {
    await store.dispatch("simplificadoStore/desligarUsuario", {
      id: dadosUsuarioEdicao.value.id,
    });
    detalharUsuario();
    quasar.notify({
      message: "Usuário desligado.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
  }
};

const afastarUsuario = async () => {
  try {
    await store.dispatch("simplificadoStore/afastarUsuario", {
      id: dadosUsuarioEdicao.value.id,
      status: "Afastado",
    });
    detalharUsuario();
    quasar.notify({
      message: "Usuário afastado.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
  }
};

const editarUsuario = async () => {
  try {
    await store.dispatch("simplificadoStore/editarFuncionario", {
      id: dadosUsuarioEdicao.value.id,
      sap: dadosUsuarioEdicao.value.sap,
      name: dadosUsuarioEdicao.value.name,
      email: dadosUsuarioEdicao.value.email,
      cost_center_id: dadosUsuarioEdicao.value.cost_center?.id,
      function_id: dadosUsuarioEdicao.value.gheObject?.id,
      admission_date: dadosUsuarioEdicao.value.admission_date,
      roles: dadosUsuarioEdicao.value.perfil
        ? dadosUsuarioEdicao.value.perfil.id
        : undefined,
      resignation_date:
        dadosUsuarioEdicao.value.resignation_date == null
          ? undefined
          : dadosUsuarioEdicao.value.resignation_date,
      cargo: dadosUsuarioEdicao.value.cargo,
      vendor_shift_id: dadosUsuarioEdicao.value.vendor_shift_id,
      tnumber: dadosUsuarioEdicao.value.tnumber,
    });
    if (
      dadosUsuarioEdicao.value.perfil?.id != dadosUsuario.value?.roles[0]?.id
    ) {
      await alterarPerfil();
    }

    detalharUsuario();
    quasar.notify({
      message: "Alteração salva com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o fazer alteração",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const verificarAlteracoes = () => {
  if (
    dadosUsuarioEdicao.value.sap != dadosUsuario.value.sap ||
    dadosUsuarioEdicao.value.perfil?.id != dadosUsuario.value?.roles[0]?.id ||
    dadosUsuarioEdicao.value?.cargo != dadosUsuario.value?.cargo ||
    dadosUsuarioEdicao.value?.name != dadosUsuario.value?.name ||
    dadosUsuarioEdicao.value?.codigo_integracao !=
      dadosUsuario.value?.codigo_integracao ||
    dadosUsuarioEdicao.value?.email != dadosUsuario.value?.email ||
    (dadosUsuarioEdicao.value?.vendor_shift_id !=
      dadosUsuario.value?.vendor_shift_id &&
      dadosUsuarioEdicao.value?.vendor_shift_id?.value !=
        dadosUsuario.value?.vendor_shift_id) ||
    dadosUsuarioEdicao.value.admission_date !=
      dadosUsuario.value.admission_date
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/") ||
    dadosUsuarioEdicao.value.gheObject?.id != dadosUsuario.value.function_id ||
    dadosUsuarioEdicao.value.admission_date !=
      dadosUsuario.value.admission_date
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/") ||
    dadosUsuarioEdicao.value?.cost_center?.id !=
      dadosUsuario.value?.cost_center?.id
  ) {
    botaoHabilitado.value = true;
    return;
  }
  botaoHabilitado.value = false;
};

const alterarPerfil = async () => {
  try {
    await store.dispatch("simplificadoStore/editarRoles", {
      user: userId.value,
      roles: dadosUsuarioEdicao.value.perfil?.id,
    });
  } catch (error) {
    console.log(error);
  }
};

const indexarRegras = async () => {
  try {
    await store.dispatch("simplificadoStore/indexarRegras", {
      usuarios: [{ id: userId.value }],
    });
    detalharUsuario();
    quasar.notify({
      message: "Regras indexadas com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro a o indexar regras",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  [
    () => dadosUsuarioEdicao.value.sap,
    () => dadosUsuarioEdicao.value.perfil?.id,
    () => dadosUsuarioEdicao.value?.cargo,
    () => dadosUsuarioEdicao.value?.name,
    () => dadosUsuarioEdicao.value?.codigo_integracao,
    () => dadosUsuarioEdicao.value.email,
    () => dadosUsuarioEdicao.value.vendor_shift_id,
    () => dadosUsuarioEdicao.value.admission_date,
    () => dadosUsuarioEdicao.value.cost_center,
    () => dadosUsuarioEdicao.value?.gheObject?.id,
  ],
  () => {
    verificarAlteracoes();
  }
);

const myLocale = {
  days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
  daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
  months:
    "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
  monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
  firstDayOfWeek: 1,
};

onMounted(() => {
  detalharUsuario();
  getTurnos();
});

watch(
  () => userId.value,
  () => {
    detalharUsuario();
  },
  { deep: true }
);

userId.value;
</script>
